/* photo strip - drift / native scroll / mouse drag */

(function () {
  'use strict';

  var ROOT = '[data-yg-photo-strip]';
  var INTENT_THRESHOLD = 10;
  var RESUME_DELAY_MS = 1600;
  var VELOCITY_DECAY = 0.94;
  var VELOCITY_FLOOR = 0.05;
  var SPEED_UNIT = 0.14;
  var FRAME_MS = 1000 / 60;
  var BAND_LO = 0.5;
  var BAND_HI = 1.5;

  var instances = Object.create(null);
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function listenQuery(query, handler, on) {
    if (query.addEventListener) query[on ? 'addEventListener' : 'removeEventListener']('change', handler);
    else if (query.addListener) query[on ? 'addListener' : 'removeListener'](handler);
  }

  function stripEditorAttrs(root) {
    var els = root.querySelectorAll('[data-shopify-editor-block-id], [data-block-id]');
    for (var i = 0; i < els.length; i++) {
      var attrs = Array.prototype.slice.call(els[i].attributes);
      for (var j = 0; j < attrs.length; j++) {
        var name = attrs[j].name;
        if (name.indexOf('data-shopify') === 0 || name === 'data-block-id') {
          els[i].removeAttribute(name);
        }
      }
    }
  }

  function ensureClones(rail, viewportWidth) {
    var originals = Array.prototype.slice.call(rail.children);
    if (!originals.length) return 0;

    if (rail.dataset.psCloned === 'true') {
      return parseFloat(rail.dataset.psSegment) || 0;
    }

    var setWidth = rail.scrollWidth;
    var sets = setWidth > 0 ? Math.ceil(BAND_HI + 1 + (viewportWidth + 100) / setWidth) : 1;
    var originalCount = originals.length;

    for (var c = 1; c < sets; c++) {
      for (var i = 0; i < originals.length; i++) {
        var clone = originals[i].cloneNode(true);
        stripEditorAttrs(clone);
        clone.dataset.psClone = 'true';
        clone.setAttribute('aria-hidden', 'true');
        var focusables = clone.querySelectorAll('[tabindex="0"], a, button');
        for (var k = 0; k < focusables.length; k++) {
          focusables[k].setAttribute('tabindex', '-1');
        }
        rail.appendChild(clone);
      }
    }

    rail.dataset.psCloned = 'true';
    rail.dataset.psSets = String(sets);
    rail.dataset.psOriginals = String(originalCount);
    rail.dataset.psSegment = String(measureSegment(rail));
    return parseFloat(rail.dataset.psSegment);
  }

  function measureSegment(rail) {
    var originalCount = parseFloat(rail.dataset.psOriginals) || 0;
    var first = rail.children[0];
    var firstClone = rail.children[originalCount];
    if (first && firstClone) {
      var period = firstClone.offsetLeft - first.offsetLeft;
      if (period > 0) return period;
    }
    var sets = parseFloat(rail.dataset.psSets) || 2;
    return rail.scrollWidth / sets;
  }

  function attach(root) {
    var viewport = root.querySelector('[data-yg-ps-viewport]');
    var rail = root.querySelector('[data-yg-ps-rail]');
    if (!viewport || !rail || !rail.children.length) return null;

    var destroyed = false;
    var rate = ((parseFloat(root.dataset.autoscroll) || 0) * SPEED_UNIT) / FRAME_MS;
    var segment = ensureClones(rail, Math.max(viewport.clientWidth, window.innerWidth));
    var room = 0;
    var lastWidth = viewport.clientWidth;
    var anim = null;
    var visible = false;
    var held = false;
    var pressing = false;
    var scrolledSincePress = false;
    var ignoreScroll = false;
    var resumeTimer = null;
    var resizeTimer = null;
    var observer = null;

    var dragging = false;
    var dragPending = false;
    var pointerId = null;
    var startX = 0;
    var lastX = 0;
    var lastT = 0;
    var velocity = 0;
    var carry = 0;
    var momentumId = null;

    function measureRoom() {
      room = viewport.scrollWidth - viewport.clientWidth;
    }

    function setScroll(x) {
      ignoreScroll = true;
      viewport.scrollLeft = x;
      requestAnimationFrame(function () {
        ignoreScroll = false;
      });
    }

    function wrap() {
      if (segment <= 0 || room < segment * BAND_HI) return;
      var x = viewport.scrollLeft;
      if (x >= segment * BAND_HI) viewport.scrollLeft = x - segment;
      else if (x < segment * BAND_LO) viewport.scrollLeft = x + segment;
    }

    function updatePlayState() {
      if (!anim) return;
      var run = visible && !held && !REDUCED.matches;
      if (run && anim.playState !== 'running') anim.play();
      else if (!run && anim.playState === 'running') anim.pause();
    }

    function buildAnimation() {
      var fraction = 0;
      if (anim) {
        var oldDuration = anim.effect.getTiming().duration;
        fraction = ((anim.currentTime || 0) % oldDuration) / oldDuration;
        anim.cancel();
        anim = null;
      }
      if (!rate || segment <= 0 || !rail.animate) return;

      var duration = segment / rate;
      anim = rail.animate(
        [{ transform: 'translateX(0)' }, { transform: 'translateX(' + -segment + 'px)' }],
        { duration: duration, iterations: Infinity, easing: 'linear' }
      );
      anim.pause();
      anim.currentTime = fraction * duration;
      updatePlayState();
    }

    function hold() {
      held = true;
      clearTimeout(resumeTimer);
      updatePlayState();
    }

    function releaseAfter(ms) {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () {
        if (pressing || momentumId) return;
        held = false;
        updatePlayState();
      }, ms);
    }

    function stopMomentum() {
      if (momentumId) cancelAnimationFrame(momentumId);
      momentumId = null;
    }

    function momentum() {
      carry += velocity;
      velocity *= VELOCITY_DECAY;
      if (Math.abs(carry) >= 1) {
        var whole = carry > 0 ? Math.floor(carry) : Math.ceil(carry);
        viewport.scrollLeft += whole;
        carry -= whole;
        wrap();
      }
      if (Math.abs(velocity) > VELOCITY_FLOOR) {
        momentumId = requestAnimationFrame(momentum);
      } else {
        momentumId = null;
        releaseAfter(RESUME_DELAY_MS);
      }
    }

    function onPointerDown(event) {
      pressing = true;
      scrolledSincePress = false;
      stopMomentum();
      hold();

      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      if (event.target.closest && event.target.closest('a, button')) return;
      dragPending = true;
      pointerId = event.pointerId;
      startX = lastX = event.clientX;
      lastT = performance.now();
      velocity = 0;
      carry = 0;
    }

    function onPointerMove(event) {
      if (event.pointerId !== pointerId || (!dragPending && !dragging)) return;
      if (!dragging) {
        if (Math.abs(event.clientX - startX) < INTENT_THRESHOLD) return;
        dragging = true;
        dragPending = false;
        viewport.setPointerCapture(event.pointerId);
        viewport.classList.add('is-dragging');
      }

      event.preventDefault();
      viewport.scrollLeft += lastX - event.clientX;
      wrap();

      var now = performance.now();
      var dt = now - lastT || 16;
      velocity = ((lastX - event.clientX) / dt) * 16;
      lastX = event.clientX;
      lastT = now;
    }

    function onPointerEnd(event) {
      pressing = false;
      var wasDragging = dragging;
      dragging = false;
      dragPending = false;

      if (wasDragging && event.pointerId === pointerId) {
        viewport.classList.remove('is-dragging');
        if (viewport.hasPointerCapture(event.pointerId)) viewport.releasePointerCapture(event.pointerId);
        if (Math.abs(velocity) > VELOCITY_FLOOR) {
          momentumId = requestAnimationFrame(momentum);
          return;
        }
      }
      pointerId = null;

      if (event.type === 'pointercancel' && !scrolledSincePress) {
        held = false;
        clearTimeout(resumeTimer);
        updatePlayState();
        return;
      }
      releaseAfter(RESUME_DELAY_MS);
    }

    function onScroll() {
      wrap();
      if (ignoreScroll) return;
      scrolledSincePress = true;
      hold();
      if (!pressing && !momentumId) releaseAfter(RESUME_DELAY_MS);
    }

    function onIntersect(entries) {
      visible = entries[entries.length - 1].isIntersecting;
      updatePlayState();
    }

    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (destroyed || viewport.clientWidth === lastWidth) return;
        lastWidth = viewport.clientWidth;
        var settled = measureSegment(rail);
        measureRoom();
        if (settled > 0 && Math.abs(settled - segment) > 2) {
          var fraction = segment > 0 ? viewport.scrollLeft / segment : 1;
          segment = settled;
          rail.dataset.psSegment = String(segment);
          setScroll(segment * fraction);
          buildAnimation();
        }
      }, 150);
    }

    viewport.addEventListener('pointerdown', onPointerDown);
    viewport.addEventListener('pointermove', onPointerMove);
    viewport.addEventListener('pointerup', onPointerEnd);
    viewport.addEventListener('pointercancel', onPointerEnd);
    viewport.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    listenQuery(REDUCED, updatePlayState, true);

    measureRoom();
    setScroll(segment > 0 ? segment - 1 : 0);
    buildAnimation();

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(onIntersect);
      observer.observe(viewport);
    } else {
      visible = true;
      updatePlayState();
    }

    return {
      destroy: function () {
        destroyed = true;
        stopMomentum();
        clearTimeout(resumeTimer);
        clearTimeout(resizeTimer);
        if (observer) observer.disconnect();
        if (anim) anim.cancel();
        viewport.removeEventListener('pointerdown', onPointerDown);
        viewport.removeEventListener('pointermove', onPointerMove);
        viewport.removeEventListener('pointerup', onPointerEnd);
        viewport.removeEventListener('pointercancel', onPointerEnd);
        viewport.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onResize);
        listenQuery(REDUCED, updatePlayState, false);
      },
    };
  }

  function init() {
    var roots = document.querySelectorAll(ROOT);
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      var sectionId = root.dataset.sectionId;
      if (!sectionId || instances[sectionId]) continue;

      var controller = attach(root);
      if (controller) instances[sectionId] = controller;
    }
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function (event) {
    var sectionId = event.detail && event.detail.sectionId;
    if (!sectionId || !instances[sectionId]) return;
    instances[sectionId].destroy();
    delete instances[sectionId];
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
